export default __webpack_public_path__ + "static/снимок-экрана-2021-07-22-в-14.56.48-649d820ed16b78b56a41af1ff50c4cea.png";